<template>
  <section  :style="{ 'background-image': `url(${imageBackground})` }" class="px-14 sm-max:px-5 bg-cover pb-14 md-max:pb-8">
    <div class="pt-6">
      <div class="grid sm-max:block grid-cols-12 mt-6 gap-8">
        <div class="col-span-7 md-max:col-span-12 text-white">
          <div class="lg:text-19 md:text-17 text-15 sm-max:!leading-5 leading-26 md-max:text-base" v-html="paragraphOne"></div>
          <br/>
          <div class="lg:text-19 md:text-17 text-15 leading-26 sm-max:!leading-5 md-max:text-base" v-html="paragraphTwo"></div>
        </div>
        <div class="col-span-5 md-max:col-span-12 flex items-center sm-max:pt-4">
          <nuxt-img
              class="m-auto sm:w-full mt-0"
              width="504"
              height="336"
              loading="lazy"
              :alt="imageOneAlt"
              format="webp"
              sizes="sm:440px md:100vw lg:100vw xl:504px"
              :src="imageOneSrc"
          ></nuxt-img>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>

defineProps({
  paragraphOne: {
    type: String,
    default: 'High above sea level, in the verdant highlands of Nueva Segovia, lies La Esperanza Farm. Here, Oscar Flores Cruz cultivates Caturra and Catimor coffee on eight hectares (approx the size of 8 football fields) of dreams, ambition, and love. Oscar\'s journey began in 2000, not from legacy, but from humble beginnings and relentless determination.'
  },
  paragraphTwo: {
    type: String,
    default: 'Coffee is not just a job for Oscar, it\'s his lifeblood, a magical elixir that nourishes his family. He finds joy in the continuous work, the harvest, the washing, and drying of beans. His farm, La Esperanza, or \'The Hope,\' embodies his dreams and aspirations. The name signifies his unyielding faith that through coffee, he would achieve his goals.'
  },
  imageOneSrc: {
    type: String,
    default: '/assets/images/IMG_2287.jpg'
  },
  imageOneAlt: {
    type: String,
    default: 'Image of Oscar Flores Cruz\'s farm'
  },
  imageBackground: {
    type: String,
    default: '/assets/images/freebag-sect10-bg.jpg'
  }
})

defineBuilderComponent({
    friendlyName: "ResilienceHopeCup-2",
    canHaveChildren: true,
    inputs: [
        {
            name: "imageBackground",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "svg",
                "png"
            ],
            required: true,
            defaultValue: "/assets/images/freebag-sect10-bg.jpg"
        },
        {
            name: "paragraphOne",
            type: "richText",
            defaultValue: "High above sea level, in the verdant highlands of Nueva Segovia, lies La Esperanza Farm. Here, Oscar Flores Cruz cultivates Caturra and Catimor coffee on eight hectares (approx the size of 8 football fields) of dreams, ambition, and love. Oscar's journey began in 2000, not from legacy, but from humble beginnings and relentless determination."
        },
        {
            name: "paragraphTwo",
            type: "richText",
            defaultValue: "Coffee is not just a job for Oscar, it's his lifeblood, a magical elixir that nourishes his family. He finds joy in the continuous work, the harvest, the washing, and drying of beans. His farm, La Esperanza, or 'The Hope,' embodies his dreams and aspirations. The name signifies his unyielding faith that through coffee, he would achieve his goals."
        },
        {
            name: "imageOneSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "svg",
                "png"
            ],
            required: true,
            defaultValue: "/assets/images/IMG_2287.jpg"
        },
        {
            name: "imageOneAlt",
            type: "string",
            defaultValue: "Image of Oscar Flores Cruz's farm"
        },
    ]
});
</script>